// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/sharepoint/v1/sharepoint.proto (package mono.sharepoint.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { BatchCheckDocumentPermissionRequest, BatchCheckDocumentPermissionResponse, CheckDocumentPermissionRequest, CheckDocumentPermissionResponse, ExchangeOAuthCodeRequest, ExchangeOAuthCodeResponse, FilterDocumentsByACLRequest, FilterDocumentsByACLResponse, GenerateOAuthStateRequest, GenerateOAuthStateResponse, GetDriveItemContentRequest, GetDriveItemContentResponse, GetSessionRequest, GetSessionResponse, GetUserSiteAccessRequest, GetUserSiteAccessResponse, ListDriveItemsRequest, ListDriveItemsResponse, ListSiteDrivesRequest, ListSiteDrivesResponse, RevokeSessionRequest, RevokeSessionResponse, SearchDocumentsRequest, SearchDocumentsResponse } from "./sharepoint_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * SharePointService provides SharePoint permission checking and OAuth management.
 *
 * --- Permission checking (service-to-service) ---
 *
 * @generated from service mono.sharepoint.v1.SharePointService
 */ export const SharePointService = {
    typeName: "mono.sharepoint.v1.SharePointService",
    methods: {
        /**
     * CheckDocumentPermission checks if a user can access a specific SharePoint document.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.CheckDocumentPermission
     */ checkDocumentPermission: {
            name: "CheckDocumentPermission",
            I: CheckDocumentPermissionRequest,
            O: CheckDocumentPermissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * BatchCheckDocumentPermission checks permissions for multiple documents.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.BatchCheckDocumentPermission
     */ batchCheckDocumentPermission: {
            name: "BatchCheckDocumentPermission",
            I: BatchCheckDocumentPermissionRequest,
            O: BatchCheckDocumentPermissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetUserSiteAccess retrieves all SharePoint sites a user has access to.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.GetUserSiteAccess
     */ getUserSiteAccess: {
            name: "GetUserSiteAccess",
            I: GetUserSiteAccessRequest,
            O: GetUserSiteAccessResponse,
            kind: MethodKind.Unary
        },
        /**
     * FilterDocumentsByACL filters documents to only those the user can access.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.FilterDocumentsByACL
     */ filterDocumentsByACL: {
            name: "FilterDocumentsByACL",
            I: FilterDocumentsByACLRequest,
            O: FilterDocumentsByACLResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListSiteDrives lists all drives (document libraries) in a SharePoint site.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.ListSiteDrives
     */ listSiteDrives: {
            name: "ListSiteDrives",
            I: ListSiteDrivesRequest,
            O: ListSiteDrivesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ListDriveItems lists files and folders in a drive or folder.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.ListDriveItems
     */ listDriveItems: {
            name: "ListDriveItems",
            I: ListDriveItemsRequest,
            O: ListDriveItemsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDriveItemContent downloads the content of a drive item (file).
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.GetDriveItemContent
     */ getDriveItemContent: {
            name: "GetDriveItemContent",
            I: GetDriveItemContentRequest,
            O: GetDriveItemContentResponse,
            kind: MethodKind.Unary
        },
        /**
     * SearchDocuments searches across SharePoint documents using Microsoft Graph Search.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.SearchDocuments
     */ searchDocuments: {
            name: "SearchDocuments",
            I: SearchDocumentsRequest,
            O: SearchDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateOAuthState creates a CSRF state for an OAuth flow.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.GenerateOAuthState
     */ generateOAuthState: {
            name: "GenerateOAuthState",
            I: GenerateOAuthStateRequest,
            O: GenerateOAuthStateResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExchangeOAuthCode exchanges an authorization code for a token.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.ExchangeOAuthCode
     */ exchangeOAuthCode: {
            name: "ExchangeOAuthCode",
            I: ExchangeOAuthCodeRequest,
            O: ExchangeOAuthCodeResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetSession checks if a user has an active SharePoint session.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.GetSession
     */ getSession: {
            name: "GetSession",
            I: GetSessionRequest,
            O: GetSessionResponse,
            kind: MethodKind.Unary
        },
        /**
     * RevokeSession clears a user's SharePoint token.
     *
     * @generated from rpc mono.sharepoint.v1.SharePointService.RevokeSession
     */ revokeSession: {
            name: "RevokeSession",
            I: RevokeSessionRequest,
            O: RevokeSessionResponse,
            kind: MethodKind.Unary
        }
    }
};
